import styled, { ITheme } from '../../../theme'
import InputRadio from './InputRadio'

const Selected = styled.div`
  display: block;
  position: relative;
  background-color: ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  border-radius: 100%;
  height: 15px;
  width: 15px;
  z-index: 5;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 15px;
    width: 15px;
    box-sizing: border-box;
    margin: auto;

    top: -5px;
    left: -5px;
  }

  ${InputRadio}:checked ~ &:before {
    border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    background: white;
  }

  ${InputRadio}:checked:disabled ~ &:before {
    border: 5px solid  ${({ theme }: ITheme) => theme.colors.palette.greyish};
    background:  ${({ theme }: ITheme) => theme.colors.palette.greyishBrown};
  }

  ${InputRadio}:disabled ~ & {
    background-color: ${({ theme }: ITheme) => theme.colors.palette.greyish};
    border-color: ${({ theme }: ITheme) => theme.colors.palette.greyish};
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export default Selected
